import React, { useRef } from 'react';
import { Backdrop } from '../../styled/Backdrop/wrappers';
import { CloseIcon } from '../../styled/Icon';
import {
  Wrapper,
  Header,
  Content,
  Footer,
  CloseIconWrapper,
  TitlteWrapper,
} from '../../styled/Modal';

interface IDialog {
  toggleCloseModal: () => void;
  children: {
    modalTitle?: JSX.Element | string;
    modalBody: JSX.Element | string;
    modalFooter?: JSX.Element | string;
  };
  title: string;
  fullwidth?: boolean;
  TopPadding?: boolean;
  border?: boolean;
  closeIcon?: boolean;
}
// Modal Component accept modal Title , modal Body ,modal Footer ,toggleCloseModal ,title
export default function Dialog({
  toggleCloseModal,
  children,
  title,
  fullwidth,
  TopPadding,
  border,
  closeIcon = true,
}: IDialog) {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Wrapper fullwidth={fullwidth} ref={ref}>
          <Header title={title} border={border}>
            <TitlteWrapper>{children.modalTitle}</TitlteWrapper>
            {closeIcon && (
              <CloseIconWrapper onClick={() => toggleCloseModal()}>
                <CloseIcon />
              </CloseIconWrapper>
            )}
          </Header>
          <Content TopPadding={TopPadding}>{children.modalBody}</Content>
          <Footer>{children.modalFooter}</Footer>
        </Wrapper>
      </div>
      <Backdrop onClick={toggleCloseModal} title="Stäng dialog" />
    </>
  );
}
